
function FormError (props) {
	return <>{(typeof props.errors !== "undefined" && props.errors.length > 0) ?
		<div className="form-error" style = { props.errors.length > 0 ? {display:'block'} :  {display:'none'}}  >
			{props.errors.map( (error)=>(
				<p>{error}</p>
			))}
		</div>
		:''}</>;
} 

export  {FormError};